import React from 'react'
import { Bag } from '@components/icons'
import { useCartItemsCount } from '@components/alfakher/pylot-cart-manager/src/hooks/use-cart-items-count'
import { useTranslation } from 'react-i18next'
import { useUI } from '@corratech/pylot-ui/context'
import { useCart } from '@corratech/pylot-cart-manager'
import { Button } from '@corratech/pylot-ui'
import cn from 'classnames'
// @ts-ignore
import s from 'stores/ooka_default/styles/common/menus/MobileMegaMenu.module.scss'
type AddToCartIconProps = {
    isOpen: boolean
    cartStyle: string
}
export const AddToCartIcon = ({
    isOpen,
    cartStyle
}: AddToCartIconProps): JSX.Element | null => {
    const { t } = useTranslation()
    const { data: cartData } = useCart()
    const { toggleSidebar } = useUI()
    const cartItemsCount = useCartItemsCount(cartData?.data?.cart?.items)
    return (
        <div
            className={cn(
                s.item,
                {
                    [s.activeMobile]: isOpen,
                    [s.inactiveMobile]: !isOpen
                },
                s['bagIcon']
            )}
        >
            <Button
                className={cn(s['bag-btn'])}
                variant="link"
                onClick={toggleSidebar}
                aria-label={t('Bag')}
            >
                <Bag />
                {cartItemsCount && cartItemsCount > 0 ? (
                    <span className={cartStyle}>{cartItemsCount}</span>
                ) : (
                    ''
                )}
            </Button>
        </div>
    )
}
export default AddToCartIcon
